import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import sys from './modules/sys'
import user from './modules/user'
import home from './modules/home'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    sys,
    user,
    menu,
    home
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js